import {
	applyMiddleware,
	compose,
	legacy_createStore as createStore,
} from 'redux';
import immutableStateInvariant from 'redux-immutable-state-invariant';
import { withExtraArgument } from 'redux-thunk';

import { apiThunk } from '../actions';
import { rootReducer } from '../reducers';

declare global {
	var __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
}

const composeEnchancers =
	globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleWares = [
	immutableStateInvariant() as any,
	withExtraArgument(apiThunk),
];

const store = createStore(
	rootReducer,
	undefined,
	composeEnchancers(applyMiddleware(...middleWares))
);

export default store;
